/**
 * This service class holds all the logic and date manipulation methods.
 */

import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class DateService {

  /**
   * Converts any date to locale string. This method has to be strictly called in same sequence of parameters.
   * This method will return date as 22 Jul 2021 if it is called with converDateToLocaleString(22, 07, 2021)
   * @param dd day as number
   * @param mm month as number
   * @param yyyy year as number
   * @returns string
   */
  public convertDateToLocaleString = (dd: number, mm: number, yyyy: number): string => {
    const d = new Date(yyyy, mm, dd);
    let ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d);
    let mo = new Intl.DateTimeFormat('en', { month: 'short' }).format(d);
    let da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d);
    return `${da} ${mo}, ${ye}`;
  }

  public convertMonthToString = (month: string) => {
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    return months.indexOf(month);
  }

  public convertstringToMonth = (index) => {
    console.log(Number(index))
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    return months[Number(index)];
  }

}
